import React, {Component} from 'react';
import userImage from '../../assets/128x128.jpg';
import * as ChatActions from '../../store/actions/chatActions';
import api from '../../utils/api';
import jwt from 'jsonwebtoken';
import {Link} from 'react-router-dom';

class ChatSidebar extends Component {
    
    constructor(props){
        super(props);
        
        this.state = {
            userSearch: ''
        }
    }
    
    createThread = (profile) => {
        let thread = {
            users: [this.props.user.user.Profile.id, profile.id],
            createdAt: new Date(),
            status: 1,
            lastActivity: new Date()
        }
        
        
        let command = jwt.sign({
                        command: {
                          type: 'CREATE_THREAD',
                          thread: thread,
                            token: this.props.user.id
                        }}, '#&r7%+UbWU8Hc');
        this.props.socket.send(command)
      
        //this.props.createThread(thread, this.props.user.id);
    }

    initSearch = (e) => {
        this.props.messengerSearch(this.state.searchUsers, this.props.user.id);
    }
    
    render(){
        let {settings} = this.props;

        let disableStudentChat = false;
        let disableCourseChat = false;

        if (settings.filter(s => s.name === "disableStudentChat").length > 0) {
            disableStudentChat = settings.filter(s => s.name === "disableStudentChat")[0].value;
        }

        if (settings.filter(s => s.name === "disableCourseChat").length > 0) {
            disableCourseChat = settings.filter(s => s.name === "disableCourseChat")[0].value;
        }

        return (
            <div className="chat-left">
                <div className="search-chat">
                    <input 
                        type="text" 
                        className="form-control search_chat" 
                        placeholder="Search Messages" 
                        value={this.state.searchUsers || ''} 
                        onChange={e => this.setState({searchUsers: e.target.value})}
                        onKeyUp={e => {
                            if(e.keyCode === 13){
                                this.initSearch(e);
                            }
                        }}
                    />
                </div>
                <div className="chat-left-heading">
                    <p>Course Work</p>
                </div>
                <div className="chat-subjects-list">
                    <ul>
                    
                        {
                            this.props.threads.filter(t => t.title === 'announcements').map((t, i) => {
                                return (
                                    <li key={i} className={(window.location.href.indexOf(t.id) > -1) ? 'active' : ''}>
                                        <h4><Link to={`/chat/${t.id}`}><span className="chat-subject-icon bg-announcements">A</span> Announcements</Link> 
                                        {t.unread > 0 &&
                                            <span class="label label-info">{t.unread}</span>
                                        }    
                                        </h4>
                                    </li>
                                    )  
                                })
                            
                        }
                    
                        {(disableCourseChat === false || disableCourseChat === "false") && 
                            this.props.threads.filter(t => !t.ticket && t.subjectId).map((t, i) => {
                                return (
                                    <li key={i}  className={(window.location.href.indexOf(t.id) > -1) ? 'active' : ''}>
                                        <h4><Link to={`/chat/${t.id}`}><span className="chat-subject-icon bg-general">I</span> Instructor Chat</Link> 
                                            {t.unread > 0 &&
                                                    <span class="label label-info">{t.unread}</span>
                                                }
                                        </h4>
                                    </li>
                                    )  
                                })
                            
                        }
                    
                        {(disableCourseChat === false || disableCourseChat === "false") && 
                        this.props.courseUser.length > 0 &&
                            this.props.courseUser.map(cu => {
                                if(cu.subjectOrder){
                                    return cu.subjectOrder.map((s, si) => {
                                        let subject = null;
                                        if(this.props.course){
                                            if(this.props.course.CourseSubject){
                                                let sList = this.props.course.CourseSubject.filter(sub => sub.id === s);
                                                if(sList.length > 0){
                                                    subject = sList[0];
                                                }
                                            }
                                        }
                                        if(subject){
                                            let ticketsWithUnread = this.props.threads.filter(t => t.subjectId === s && t.ticket && t.unread > 0).length;
                                            return (
                                                <li key={si}  className={(window.location.href.indexOf(s) > -1) ? 'active' : ''}>
                                                    <h4><Link to={'/chat/tickets/' + s}><span className={`chat-subject-icon subject-panel-bg-${si} ${cu.currentSubject !== subject.id ? 'subject-locked' : ''}`}>{(subject) ? subject.name[0] : ''}</span> {(subject) ? subject.name : 'Subject Thread'}</Link>
                                                        {ticketsWithUnread > 0 &&
                                                                <span class="label label-info">{ticketsWithUnread}</span>
                                                            }
                                                    </h4>
                                                </li>
                                            )
                                        }else{
                                            return null;
                                        }
                                    })
                                }else{
                                    return null;
                                }
                            })
                            
                        }
                    </ul>
                </div>
                {(disableStudentChat === false || disableStudentChat === "false") && 
                <div className="chat-left-heading">
                    <div className="flex flex-justify-content-space-between flex-align-items-center">
                        <p>Friends</p>
                        <div>
                            <input type="checkbox" className={`ios8-switch ios-switch-small`} checked={this.props.online} onChange={e => {
                            
                            let command = jwt.sign({
                                    command: {
                                    online: !this.props.online,
                                    profileId: this.props.user.user.Profile.id,
                                    type: 'STATUS_CHANGE',
                                    token: this.props.user.id
                                }}, '#&r7%+UbWU8Hc');
                            this.props.socket.send(command)
                                
           
                            }} id="messenger_noti_14" />
                            <label htmlFor="messenger_noti_14"></label>

                        </div>
                    </div>
                </div>
                }
                <div className="peers_list" style={{opacity: (this.props.online) ? '1' : '0.1'}}>
                    <ul>
                        {this.state.searchUsers && (disableStudentChat === false || disableStudentChat === "false") ?
                            this.props.users.filter(u => {
                                let searchString = u.name + ' ' + u.lname + ' ' + u.id + ' ' + u.email;
                                return u.id !== this.props.user.user.Profile.id;
                                
                            }).map((t, i) => {
                                let profile = t;
                                let thread = this.props.threads.filter(t => t.users.indexOf(profile.id) > -1 && !t.ticket);
                                
                                if(profile){
                                  return (
                                      <li key={i}  className={(window.location.href.indexOf(t.id) > -1) ? 'active' : ''}>
                                        <Link to={(thread.length > 0) ? `/chat/${thread[0].id}` : `/chat/users/${t.id}`} onClick={e => {
                                            if(thread.length === 0){
                                                e.preventDefault();
                                                this.props.createThread(t);
                                            }
                                        }}>
                                            {profile.image ?
                                                            <span>
                                                                {profile.image.indexOf('http') === -1 ?
                                                                    <img src={api.makeFileURL(profile.image) || userImage}  />
                                                                :
                                                                    <img src={(profile.image) ? profile.image : userImage}  />
                                                                }
                                                            </span>
                                                            
                                                            :
                                                            <img src={(profile.image) ? profile.image : userImage}  />
                                                        }
                                            <h3>{profile.name} {profile.lname}</h3>
                                            
                                            </Link>
                                        </li>
                                    )  
                                }
                            })
                        
                        :
                        (disableStudentChat === false || disableStudentChat === "false") &&
                        this.props.threads.filter(t => !t.ticket && !t.subjectId).map((t, i) => {
                            if(t.Profiles){
                                let profile = t.Profiles.filter(p => p.id !== this.props.user.user.Profile.id)[0];
                                if(profile){
                                    if(t.Messages){
                                    if(t.Messages.length > 0 || window.location.href.indexOf(t.id) > -1){
                                          return (
                                              <li key={i} className={`${t.blockedBy.indexOf(this.props.user.user.Profile.id) > -1 ? 'blockedChatUser' : t.mutedBy.indexOf(this.props.user.user.Profile.id) > -1 ? 'mutedChatUser': ''} ${(window.location.href.indexOf(t.id) > -1) ? 'active' : ''}`}>
                                                <Link to={`/chat/${t.id}`}>
                                                    {profile.image ?
                                                        <span>
                                                            {profile.image.indexOf('http') === -1 ?
                                                                <img src={api.makeFileURL(profile.image) || userImage}  />
                                                            :
                                                                <img src={(profile.image) ? profile.image : userImage}  />
                                                            }
                                                        </span>
                                                        
                                                        :
                                                        <img src={(profile.image) ? profile.image : userImage}  />
                                                    }
                                                    <h3>{profile.name} {profile.lname}
                                                    
                                                    
                                                    {t.unread > 0 &&
                                                        <span class="label label-info">{t.unread}</span>
                                                    }</h3>
                                                    
                                                    </Link>
                                                </li>
                                            )  
                                        }
                                    }
                                }
                            }
                            })}
                    </ul>
                </div>
            </div>
            )
    }
}

export default ChatSidebar;


// WEBPACK FOOTER //
// ./src/components/Chat/ChatSidebar.js